export default __webpack_public_path__ + "monster.33e905fe.png";